import React from 'react';

import { Colors } from 'constants/theme';

interface Props {
  color?: string;
  height?: number;
  width?: number;
}

export const Logo: React.FC<Props> = ({
  color,
  height = 24,
  width = 179,
  ...props
}) => (
  <svg
    fill="none"
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M176.411 12.3715C175.854 12.3715 175.285 12.5651 174.91 12.9978V11.5739V10.0744V10.0709L174.902 10.0782L173.73 10.6867V11.1918V11.5739V18.1568H174.91V14.5694C175.125 13.8974 175.586 13.5671 176.186 13.5671C176.98 13.5671 177.409 14.2278 177.409 14.8428V18.1568H178.588V14.8199C178.588 13.3508 177.741 12.3715 176.411 12.3715Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M168.717 12.4627H169.51V11.3694L170.69 10.7545V12.4627H172.063L172.062 13.5788H170.69V16.164C170.69 16.7448 170.84 17.0066 171.451 17.0066H172.191V18.157H171.151C170.121 18.157 169.51 17.5077 169.51 16.4258V13.5788H168.717V12.4627Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M166.225 10.6869V18.1569H167.404V10.0745L166.225 10.6869Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M163.318 17.7845C162.943 18.1034 162.449 18.2857 161.881 18.2857C160.294 18.2857 159.125 17.01 159.125 15.3474C159.125 13.6847 160.294 12.4092 161.881 12.4092C162.449 12.4092 162.943 12.6029 163.318 12.9217V12.4089H164.498V18.1946H163.318V17.7845ZM163.318 14.3794C163.029 13.9126 162.482 13.605 161.892 13.605C160.98 13.605 160.337 14.3567 160.337 15.3474C160.337 16.3383 160.98 17.0899 161.892 17.0899C162.482 17.0899 163.029 16.7824 163.318 16.3154V14.3794Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M152.738 15.3097C152.738 13.6471 153.918 12.3716 155.484 12.3716C156.974 12.3716 157.972 13.4877 158.047 15.3097V15.6514H153.961C154.079 16.46 154.701 17.0066 155.505 17.0066C156.148 17.0066 156.62 16.6878 156.899 16.3576L157.693 17.2572C157.232 17.8266 156.449 18.2481 155.505 18.2481C153.918 18.2481 152.738 16.9724 152.738 15.3097ZM153.993 14.6834H156.749C156.61 13.9089 156.106 13.5217 155.398 13.5217C154.765 13.5217 154.186 13.9661 153.993 14.6834Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M151.495 10.0645L150.251 10.7102V11.6458V13.4126H146.476V11.6458V10.0645H146.476L145.232 10.7102V11.399V18.2763H146.476V14.6883H150.251V18.2763H151.495V11.6458V10.0645H151.495Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M137.609 17.8266L135.496 12.4285H136.762L138.22 16.3575L139.689 12.4285H140.955L137.888 20.2181H136.644L137.609 17.8266Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M129.619 15.3559C129.619 13.6932 130.799 12.4177 132.365 12.4177C133.855 12.4177 134.853 13.5338 134.928 15.3559V15.6975H130.842C130.96 16.5061 131.582 17.0527 132.386 17.0527C133.029 17.0527 133.501 16.7338 133.78 16.4037L134.574 17.3032C134.113 17.8727 133.33 18.2941 132.386 18.2941C130.799 18.2941 129.619 17.0185 129.619 15.3559ZM130.874 14.7295H133.63C133.491 13.9551 132.987 13.5679 132.279 13.5679C131.646 13.5679 131.067 14.0121 130.874 14.7295Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M126.99 10.7258V18.267H128.17V10.1135H128.17L126.99 10.7258Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M121.715 17.1325L122.616 16.4492C122.873 16.916 123.173 17.1781 123.71 17.1781C124.117 17.1781 124.396 16.9617 124.396 16.6542C124.396 16.3239 124.171 16.1303 123.677 15.9367L123.302 15.7773C122.391 15.4014 121.994 14.7979 121.994 14.0235C121.994 13.101 122.723 12.4177 123.72 12.4177C124.407 12.4177 124.996 12.7024 125.393 13.4085L124.525 14.0462C124.342 13.6932 124.085 13.5339 123.742 13.5339C123.431 13.5339 123.152 13.7045 123.152 13.9893C123.152 14.2854 123.334 14.4677 123.838 14.684L124.224 14.832C125.125 15.2078 125.629 15.709 125.629 16.5972C125.629 17.5994 124.846 18.2942 123.71 18.2942C122.862 18.2942 122.155 17.9297 121.715 17.1325Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M117.963 12.4167L119.143 12.4171V13.0662C119.486 12.6334 119.947 12.4284 120.526 12.4284C120.665 12.4284 120.794 12.4398 120.912 12.4626V13.7723C120.751 13.7153 120.547 13.6926 120.322 13.6926C119.818 13.6926 119.378 13.8975 119.143 14.3759V18.2024H117.963V12.4167Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M115.174 17.7924C114.798 18.1113 114.305 18.2936 113.737 18.2936C112.149 18.2936 110.98 17.018 110.98 15.3553C110.98 13.6927 112.149 12.4172 113.737 12.4172C114.305 12.4172 114.798 12.6108 115.174 12.9296V12.4091H116.353V18.2025H115.174V17.7924ZM115.174 14.3873C114.884 13.9205 114.337 13.6129 113.747 13.6129C112.836 13.6129 112.192 14.3646 112.192 15.3553C112.192 16.3462 112.836 17.0978 113.747 17.0978C114.337 17.0978 114.884 16.7903 115.174 16.3233V14.3873Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M105.619 10.113H107.893C109.469 10.113 110.552 11.1609 110.552 12.6869C110.552 14.1901 109.469 15.2606 107.893 15.2606H106.863V18.1989H105.619V10.113ZM107.839 14.0307C108.751 14.0307 109.287 13.4954 109.287 12.6868C109.287 11.8784 108.751 11.3431 107.839 11.3431H106.863V14.0307H107.839Z"
      fill={color || Colors.sage6}
      fillRule="evenodd"
    />
    <path
      d="M89.0332 18.1341H92.1701C93.7045 18.1341 94.7729 17.1112 94.7729 15.77C94.7729 14.7699 94.216 14.1561 93.4772 13.8492C93.9205 13.5196 94.2273 13.0082 94.2273 12.2921C94.2273 11.0874 93.2613 10.0645 91.8178 10.0645H89.0332V18.1341ZM90.363 13.4628V11.2806H91.7496C92.477 11.2806 92.9203 11.7807 92.9203 12.3717C92.9203 12.9854 92.477 13.4628 91.7496 13.4628H90.363ZM90.363 16.918V14.5994H92.136C92.9998 14.5994 93.4772 15.0995 93.4772 15.7587C93.4772 16.4293 92.9885 16.918 92.136 16.918H90.363Z"
      fill={color || Colors.sage6}
    />
    <path
      d="M97.8186 20.5096L101.467 12.4513H100.08L98.3415 16.4747L96.5911 12.4513H95.2159L97.6595 17.8272L96.4434 20.5096H97.8186Z"
      fill={color || Colors.sage6}
    />
    <path
      d="M0 18.6092H1.86055V1.13231H0V18.6092Z"
      fill={color || Colors.sage6}
    />
    <path
      d="M5.91005 18.6092H7.62371V12.48C7.62371 9.42769 9.28842 7.65538 11.4427 7.65538C13.2543 7.65538 14.5273 8.98461 14.5273 11.1508V18.6092H16.241V10.9046C16.241 7.90154 14.307 6.05538 11.6386 6.05538C10.0473 6.05538 8.50503 6.74462 7.62371 8.36923V6.30154H5.91005V18.6092Z"
      fill={color || Colors.sage6}
    />
    <path
      d="M23.339 18.8554C25.7136 18.8554 27.4518 17.6 27.4518 15.2615C27.4518 13.4646 26.2767 12.3569 24.1958 11.6923L22.8004 11.2492C21.356 10.7815 20.8909 10.1169 20.8909 9.25538C20.8909 8.24615 22.017 7.58154 23.1676 7.58154C24.4651 7.58154 25.3464 8.29538 25.8605 9.08308L27.2314 8.22154C26.4725 6.84308 25.0526 6.05538 23.2655 6.05538C20.9888 6.05538 19.1772 7.26154 19.1772 9.32923C19.1772 11.0031 20.1809 12.2092 22.1149 12.8246L23.4369 13.2431C25.1261 13.7846 25.7381 14.4246 25.7381 15.4092C25.7381 16.6154 24.6854 17.3046 23.3634 17.3046C21.968 17.3046 20.5481 16.5415 20.132 15.1877L18.5896 15.8277C19.2262 17.8462 21.1357 18.8554 23.339 18.8554Z"
      fill={color || Colors.sage6}
    />
    <path
      d="M31.1059 2.60923C31.8159 2.60923 32.3789 2.01846 32.3789 1.30462C32.3789 0.590769 31.8159 0 31.1059 0C30.3715 0 29.7839 0.590769 29.7839 1.30462C29.7839 2.01846 30.3715 2.60923 31.1059 2.60923ZM30.2246 18.6092H31.9383V6.30154H30.2246V18.6092Z"
      fill={color || Colors.sage6}
    />
    <path
      d="M40.8539 24C44.2568 24 46.9007 21.9815 46.9007 17.9692V6.30154H45.1871V8.36923C44.3057 7.04 42.5921 6.05538 40.707 6.05538C37.2307 6.05538 34.6602 8.81231 34.6602 12.3323C34.6602 15.8523 37.2307 18.6092 40.707 18.6092C42.5921 18.6092 44.3057 17.6246 45.1871 16.2954V17.8708C45.1871 21.12 42.9593 22.4 40.8539 22.4C38.7975 22.4 37.3776 21.4892 36.4229 20.16L35.0764 21.3169C36.0067 22.72 38.0386 24 40.8539 24ZM40.8784 17.0092C38.21 17.0092 36.4229 14.9908 36.4229 12.3323C36.4229 9.67385 38.21 7.65538 40.8784 7.65538C43.5468 7.65538 45.3339 9.67385 45.3339 12.3323C45.3339 14.9908 43.5468 17.0092 40.8784 17.0092Z"
      fill={color || Colors.sage6}
    />
    <path
      d="M50.6184 18.6092H52.332V12.48C52.332 9.42769 53.9968 7.65538 56.1511 7.65538C57.9627 7.65538 59.2357 8.98461 59.2357 11.1508V18.6092H60.9493V10.9046C60.9493 7.90154 59.0154 6.05538 56.3469 6.05538C54.7557 6.05538 53.2134 6.74462 52.332 8.36923V0.147692H50.6184V18.6092Z"
      fill={color || Colors.sage6}
    />
    <path
      d="M68.7117 18.7323C69.3972 18.7323 70.0092 18.6092 70.5233 18.4123V16.8615C70.1316 17.0092 69.4706 17.1323 68.981 17.1323C67.6835 17.1323 66.9491 16.6154 66.9491 15.04V7.92615H70.5233V6.30154H66.9491V2.88H65.2354V6.30154H62.616V7.92615H65.2354V15.1877C65.2354 17.6 66.7288 18.7323 68.7117 18.7323Z"
      fill={color || Colors.sage6}
    />
    <path
      d="M76.4033 18.8554C78.778 18.8554 80.5161 17.6 80.5161 15.2615C80.5161 13.4646 79.341 12.3569 77.2602 11.6923L75.8647 11.2492C74.4204 10.7815 73.9552 10.1169 73.9552 9.25538C73.9552 8.24615 75.0814 7.58154 76.232 7.58154C77.5295 7.58154 78.4108 8.29538 78.9249 9.08308L80.2958 8.22154C79.5369 6.84308 78.117 6.05538 76.3299 6.05538C74.0532 6.05538 72.2416 7.26154 72.2416 9.32923C72.2416 11.0031 73.2453 12.2092 75.1793 12.8246L76.5013 13.2431C78.1904 13.7846 78.8025 14.4246 78.8025 15.4092C78.8025 16.6154 77.7498 17.3046 76.4278 17.3046C75.0324 17.3046 73.6125 16.5415 73.1963 15.1877L71.654 15.8277C72.2905 17.8462 74.2 18.8554 76.4033 18.8554Z"
      fill={color || Colors.sage6}
    />
  </svg>
);
